var CartDiscountValueType;
(function (CartDiscountValueType) {
    CartDiscountValueType["relative"] = "relative";
    CartDiscountValueType["abslute"] = "absolute";
    CartDiscountValueType["giftLineItem"] = "giftLineItem";
})(CartDiscountValueType || (CartDiscountValueType = {}));
var CartDiscountTargetType;
(function (CartDiscountTargetType) {
    CartDiscountTargetType["lineItems"] = "lineItems";
    CartDiscountTargetType["customLineItems"] = "customLineItems";
    CartDiscountTargetType["shipping"] = "shipping";
})(CartDiscountTargetType || (CartDiscountTargetType = {}));
var StackingMode;
(function (StackingMode) {
    StackingMode["Stacking"] = "Stacking";
    StackingMode["StopAfterThisDiscount"] = "StopAfterThisDiscount";
})(StackingMode || (StackingMode = {}));
var LineItemMode;
(function (LineItemMode) {
    LineItemMode["Standard"] = "Standard";
    LineItemMode["GiftLineItem"] = "GiftLineItem";
})(LineItemMode || (LineItemMode = {}));
var ShippingRateInputType;
(function (ShippingRateInputType) {
    ShippingRateInputType["Classification"] = "Classification";
    ShippingRateInputType["Score"] = "Score";
})(ShippingRateInputType || (ShippingRateInputType = {}));
var isLenses = function (type) {
    return (typeof type === 'string' ? type : type.productType) === 'Contact-lenses';
};
var isFrames = function (type) {
    return (typeof type === 'string' ? type : type.productType) === 'Frames';
};
var isSunglasses = function (type) {
    return (typeof type === 'string' ? type : type.productType) === 'Sunglasses';
};
var isSolutions = function (type) {
    return (typeof type === 'string' ? type : type.productType) === 'Solutions';
};
var isContactLensBundle = function (type) {
    return (typeof type === 'string' ? type : type.productType) === 'Contact-lens-bundles';
};
var isAdditionalCartCosts = function (type) {
    return (typeof type === 'string' ? type : type.productType) === 'Additional-cart-costs';
};
var isProductTypeName = function (productTypeName) {
    return isLenses(productTypeName) ||
        isFrames(productTypeName) ||
        isSunglasses(productTypeName) ||
        isSolutions(productTypeName) ||
        isContactLensBundle(productTypeName);
};

var commerceToolsApi = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get CartDiscountValueType () { return CartDiscountValueType; },
  get CartDiscountTargetType () { return CartDiscountTargetType; },
  get StackingMode () { return StackingMode; },
  get LineItemMode () { return LineItemMode; },
  get ShippingRateInputType () { return ShippingRateInputType; },
  isLenses: isLenses,
  isFrames: isFrames,
  isSunglasses: isSunglasses,
  isSolutions: isSolutions,
  isContactLensBundle: isContactLensBundle,
  isAdditionalCartCosts: isAdditionalCartCosts,
  isProductTypeName: isProductTypeName
});

export { commerceToolsApi as CommerceToolsApi };
//# sourceMappingURL=index.es.js.map
